import type React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../../utils/animations';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
  light?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  centered = true,
  className = '',
  light = false,
}) => {
  const textAlignment = centered ? 'text-center' : 'text-left';
  const textColor = light ? 'text-white' : 'text-gray-900';
  const subtitleColor = light ? 'text-gray-200' : 'text-gray-600';

  return (
    <div className={`mb-12 ${textAlignment} ${className}`}>
      <motion.h2
        className={`text-3xl font-bold leading-tight md:text-4xl ${textColor}`}
        variants={fadeInUp}
      >
        {title}
      </motion.h2>

      {subtitle && (
        <motion.p
          className={`mt-4 text-lg ${subtitleColor}`}
          variants={fadeInUp}
        >
          {subtitle}
        </motion.p>
      )}

      <motion.div
        className={`mx-auto mt-6 h-1 w-24 rounded-full ${light ? 'bg-secondary' : 'bg-secondary'} ${centered ? 'mx-auto' : 'ml-0'}`}
        variants={fadeInUp}
      />
    </div>
  );
};

export default SectionHeading;
